import React, { useState, useCallback, useEffect } from "react";

import {
    Box, 
    Paper,
    Divider,
    TextField,
    Grid,
    Switch,
    FormControlLabel,
    FormGroup,
    Checkbox,
    Button,
    Card,
    styled
} from '@mui/material';

import {
  LoadingButton
} from '@mui/lab';

// import { useNavigate } from "react-router-dom";
import { useFormik } from 'formik';
import { useLocations, locationTypes, targetTypes } from "../../../hooks/api/useLocations";
import { useAppContextFeatures } from '../../../context/AppContext';

import { useSystemPrompt } from "../../../hooks/useSystemPrompt";
import { initialValues, validationSchema } from "../../../schema/locations/rackSchema";
import { useTranslations } from "../../../hooks/useTranslations";

// import CommonSectionHeader from "../common/CommonSectionHeader";
// import { CommonIcons, icons } from "../common/CommonIcons";
import { useSystemRoutes, routeTypes } from '../../../hooks/useSystemRoutes';

const StyledCard = styled(Box)(({ theme }) => ({
    padding: theme.spacing(2)
}));

export default function UpdateRack({
    id,
    parentId,
    handleOnSuccess
}) {

    const { t } = useTranslations({ ns: ["common", "@location"] })

    // const { id } = useParams();
    
    const { promptMessage } = useSystemPrompt();
    const { isLoading, update, get } = useLocations({ locationType: locationTypes.rack, targetType: targetTypes.rack });
    // const navigate = useNavigate();
    const { setSystemLoading } = useAppContextFeatures();

    // const { getRoute } = useSystemRoutes(routeTypes.admin);
    const [ savedValues, setSavedValues ] = useState()

    const onSubmit = async (currentValues) => {

        setSystemLoading(true)

        try{

            const slots = currentValues.rows.map((i)=>{
                return {
                    name: i.slotName,
                    slot_id: i?.slotId,
                    sequence: i.slotSequence,
                    status: i.slotStatus? 1 : 0 ,
                    is_default: i.defaultSlot? 1 : 0,
                    
                }
            })

            let data = {
                rack: {
                    rack_name: currentValues?.rackName,
                    sequence: currentValues?.sequence,
                    is_default : currentValues?.defaultStatus? 1 : 0,
                    status: currentValues?.status? 1 : 0,
                    rack_type: currentValues?.rackType? 1 : 0,
                },
                slots
            }
    
            const response = await update({ id, data });
    
            promptMessage(true, `${response?.message}`)

            if(handleOnSuccess) handleOnSuccess()
            
        }catch(error){
            promptMessage(false, `Action Failed (${error?.message})`)
        }

        setSystemLoading(false)
    }

    const formik = useFormik({
        initialValues: savedValues,
        validationSchema,
        enableReinitialize: true,
        onSubmit
    });

    const { values, errors, touched, handleChange, setFieldValue } = formik;  

    const loadData = async (id) => {

        setSystemLoading(true)

        try{

            const { data } = await get({ id })
            const { rack, slots } = data;

            let arraySlots = slots.map(i => {
                return {
                    slotName: i.slot_name,
                    slotId: i?.id,
                    slotSequence: i.slot_sequence,
                    slotStatus: i.status === '1',
                    defaultSlot: i.is_default === '1',
                }
            })

            setSavedValues({
                locationId: rack?.location_id,
                rackName: rack?.rack_name,
                sequence: rack?.rack_sequence,
                status: rack?.status === '1',
                defaultStatus: rack?.is_default === '1',
                rackType: rack?.rack_type === '1',
                rows: arraySlots
            })


        }catch(error){
            promptMessage(false, `${error?.message}`)
        }

        setSystemLoading(false)

    }

    useEffect(() => {

        loadData(id);

    }, [])

    const RenderForm = () => {

        if(!values) return <></>

        return(
            
            <form onSubmit={formik.handleSubmit}>
                <StyledCard>
                    <Grid container spacing={0.5}>

                        <Grid item xs={12} sm={12} md={12}>
                            <Grid container spacing={0.5}>
                                <Grid item xs={6} sm={6} md={4}> 
                                    <FormControlLabel 
                                        sx={{
                                            marginLeft:'1px'
                                        }}
                                        control={
                                            <Switch 
                                                name="status" 
                                                checked={Boolean(values.status)}
                                                onChange={(event, checked) => {
                                                    setFieldValue("status", checked);
                                                }}
                                            />
                                        }     
                                        label={
                                            Boolean(values.status)? t("enabled") : t("disabled")
                                        }
                                    />
                                </Grid>
                                {/* <Grid item xs={6} sm={6} md={4}> 
                                    <FormControlLabel 
                                        sx={{
                                            marginLeft:'1px'
                                        }}
                                        control={
                                            <Switch 
                                                name="defaultStatus" 
                                                checked={Boolean(values.defaultStatus)}
                                                onChange={(event, checked) => {
                                                    setFieldValue("defaultStatus", checked);
                                                }}
                                            />
                                        }     
                                        label={
                                            Boolean(values.defaultStatus)? "Default" : "Not Default"
                                        }
                                    />
                                </Grid> */}

                                <Grid item xs={6} sm={6} md={4}> 
                                    <FormControlLabel 
                                        sx={{
                                            marginLeft:'1px'
                                        }}
                                        control={
                                            <Switch 
                                                name="rackType" 
                                                checked={Boolean(values.rackType)}
                                                onChange={(event, checked) => {
                                                    setFieldValue("rackType", checked);
                                                }}
                                            />
                                        }     
                                        label={
                                            Boolean(values.rackType)? t("reserved") : t("normal")
                                        }
                                    />
                                </Grid>
                            
                                <Grid item xs={12} sm={12} md={10}>
                                    <TextField
                                        margin="normal"
                                        size="small"
                                        autoFocus
                                        fullWidth
                                        name={"rackName"}
                                        label={t("rackName")}
                                        type="text"                                         
                                        variant="outlined"
                                        value={values.rackName}
                                        onChange={handleChange}
                                        error={touched.rackName && Boolean(errors.rackName)}
                                        helperText={touched.rackName && errors.rackName}
                                    />
                                </Grid>

                                <Grid item xs={6} sm={6} md={2}>
                                    <TextField
                                        margin="normal"
                                        size="small"
                                        fullWidth
                                        name={"sequence"}
                                        label={t("sortNo")}
                                        type="text"                                         
                                        variant="outlined"
                                        value={values.sequence}
                                        onChange={handleChange}
                                        error={touched.sequence && Boolean(errors.sequence)}
                                        helperText={touched.sequence && errors.sequence}
                                    />
                                </Grid>
                            
                            </Grid>
                        </Grid>
                    </Grid>
                </StyledCard>

                <Box 
                    sx={{ 
                        mx: 2,
                        mr: 2
                    }}
                >
                    <LoadingButton
                        type="submit"
                        fullWidth
                        variant="contained"
                        loading={isLoading}
                    >
                        {t('saveChanges')}
                    </LoadingButton>
                </Box>
            </form>
        ) 
    }

    return (

        <Box>
                
            { RenderForm() }

        </Box>
    )
}